import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { riseIn, stagger } from '../motion';

export const List: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div className="v2-list" variants={stagger(0.05)} initial="hidden" animate="show">
    {children}
  </motion.div>
);

interface RowProps {
  thumb?: string | null;
  thumbIcon?: React.ReactNode;
  title: string;
  sub?: React.ReactNode;
  trailing?: React.ReactNode;
  onClick?: () => void;
}

/** 全画面共通の一覧の1行。サムネ・名前・補足・右端。 */
export const ListRow: React.FC<RowProps> = ({ thumb, thumbIcon, title, sub, trailing, onClick }) => {
  const Tag = onClick ? motion.button : motion.div;
  return (
    <Tag
      className={`v2-row${onClick ? ' v2-row--link' : ''}`}
      variants={riseIn}
      onClick={onClick}
      whileTap={onClick ? { scale: 0.995 } : undefined}
      layout="position"
    >
      <span className="v2-row-thumb">{thumb ? <img src={thumb} alt="" loading="lazy" /> : thumbIcon}</span>
      <span className="v2-row-body">
        <span className="v2-row-title" style={{ display: 'block' }}>
          {title}
        </span>
        {sub && (
          <span className="v2-row-sub" style={{ display: 'block' }}>
            {sub}
          </span>
        )}
      </span>
      <span className="v2-row-trail">
        {trailing}
        {onClick && <ChevronRight size={20} className="v2-row-chevron" />}
      </span>
    </Tag>
  );
};
